import React from 'react';
import {excludeClickEventIf} from "../../../../core/helpers/classNameHelper";

type CustomLabelProps = {
    labelText?: string;
    value?: number;
}

export const CustomLabel: React.FC<CustomLabelProps & { viewBox: { cx: number; cy: number } }> = ({ viewBox, labelText, value}) => {
    const {cx, cy} = viewBox;
    return (
        <g className={excludeClickEventIf(true)}>
            {value &&
                <text
                    x={cx}
                    y={cy - (labelText ? 10 : 0)}
                    textAnchor="middle"
                    dominantBaseline="central"
                    alignmentBaseline="middle"
                    fontSize="24"
                    fontWeight="600"
                >
                    {value}
                </text>
            }
            {labelText &&
                <text
                    x={cx}
                    y={cy + 10}
                    textAnchor="middle"
                    dominantBaseline="central"
                    alignmentBaseline="middle"
                    fontSize="14"
                    style={{opacity: 0.7, fill: "#888"}}
                >
                    {labelText}
                </text>
            }
        </g>
    );
};
